import moment, { Moment } from 'moment'
import React, { useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'
import { ISelect, ISelectBowtie } from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { Scrollbars, TimeSpan } from 'plugin-generic-components/shared/components/components'

import { EngineeringFilters } from './components'
import { CancelButton, SaveBar, SaveButton, SidebarContainer } from './styles'

interface IProps {
    setStartDay: (k: string | null) => void
    setEndDay: (k: string | null) => void
    setStartHour: (k: string | null) => void
    setEndHour: (k: string | null) => void
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    setPreset: (k: ISelect) => void
    filterResource: ISelect
    setFilterResource: (k: ISelect) => void
    filterBowtie: ISelectBowtie
    setFilterBowtie: (k: ISelectBowtie) => void
    bowtieData: IBowtie[]
}

export const Sidebar: React.FC<IProps> = ({
    setStartDay,
    setStartHour,
    setEndDay,
    setEndHour,
    startDay,
    startHour,
    endDay,
    endHour,
    setPreset,
    filterBowtie,
    setFilterBowtie,
    filterResource,
    setFilterResource,
    bowtieData
}) => {
    const [collapse, setCollapse] = useState(false)
    const [selectedPreset, setSelectedPreset] = useState<ISelect>()
    const [startDate, setStartDate] = useState<Moment>()
    const [endDate, setEndDate] = useState<Moment>()

    const onCollapse = (): void => {
        setCollapse(!collapse)
    }

    const onDateValidation = (): void => {
        // const st = `${startD} ${startH}`
        // const ed = `${endD} ${endH}`
        if (!filterBowtie) {
            return globalNotification.error(
                'Please, select a bowtie on bowtie filter to generate a Engineering Audit Report'
            )
        } else if (!filterResource) {
            return globalNotification.error(
                'Please, select a resource on resource filter to generate a Engineering Audit Report'
            )
        } else if (!selectedPreset) {
            return globalNotification.error(
                'Please, select a entity on entity filter to generate a Engineering Audit Report'
            )
        } else if (moment(startDate).isAfter(endDate)) {
            return globalNotification.error('End date must be greater than the start date.')
        } else if (moment(startDate).isValid && moment(endDate).isValid) {
            setStartDay((startDate as Moment).format('YYYY/MM/DD').toString())
            setStartHour((startDate as Moment).format('HH:mm').toString())
            setEndDay((endDate as Moment).format('YYYY/MM/DD').toString())
            setEndHour((endDate as Moment).format('HH:mm').toString())
            setPreset(selectedPreset)
        } else {
            return globalNotification.error(
                'Invalid date. Please follow the YYYY/MM/DD pattern for dates and hh:mm for time.'
            )
        }
    }

    const onClear = (): void => {
        setStartDay(null)
        setStartHour(null)
        setEndDay(null)
        setEndHour(null)
        setStartDate(null)
        setEndDate(null)
        setPreset(null)
        setSelectedPreset(null)
        setFilterBowtie(null)
        setFilterResource(null)
    }

    return (
        <SidebarContainer collapse={collapse}>
            <div className={'topSettings ' + collapse}>
                <div className={'TitleSidebarOn ' + collapse}>{i18n('SETTINGS')}</div>
                <div className={'TitleSidebarOff ' + collapse}>
                    <div className={'divtema ' + collapse}>{i18n('SETTINGS')}</div>
                </div>
                <button onClick={onCollapse}>
                    <i className={`${collapse ? 'fas fa-chevron-right' : 'fas fa-chevron-left'}`} />
                </button>
            </div>
            <Scrollbars className={'sidebar-reports-scrollbar ' + collapse}>
                <EngineeringFilters
                    preset={selectedPreset}
                    setPreset={setSelectedPreset}
                    filterResource={filterResource}
                    setFilterResource={setFilterResource}
                    filterBowtie={filterBowtie}
                    setFilterBowtie={setFilterBowtie}
                    bowtieData={bowtieData}
                />
                <TimeSpan startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                <SaveBar>
                    <SaveButton
                        disabled={!startDate || !endDate || !selectedPreset || !filterBowtie || !filterResource}
                        className={`btn-lg btn-bold save ${
                            !startDate || !endDate || !selectedPreset || !filterBowtie || !filterResource
                                ? 'disabled'
                                : ''
                        }`}
                        onClick={onDateValidation}
                    >
                        {i18n('Apply')}
                    </SaveButton>
                    <CancelButton className="btn-lg btn-bold cancel" type="button" onClick={onClear}>
                        {i18n('Clear')}
                    </CancelButton>
                </SaveBar>
            </Scrollbars>
        </SidebarContainer>
    )
}
